import { NgModule } from '@angular/core';
import { MatLegacyButtonModule as MatButtonModule } from '@angular/material/legacy-button';
import { SharedDirectivesModule } from '../../../pmc-layout/shared/directives/shared-directives.module';
import { SharedModule } from '../../../shared/shared.module';
import { PaymentGroupsService } from '../../../../services/payment/payment-groups.service';
import { AddClassOnHoverModule } from '../../../../directives/add-class-on-hover/add-class-on-hover.module';
import { FileUploadModule } from 'ng2-file-upload';
import { LegfiCurrencyPipe } from '../../../../pipes/format/legfi-currency.pipe';
import { LegfiCurrencyPipeModule } from '../../../../pipes/format/legfi-currency.module';
import { LegfiDatePipe } from '../../../../pipes/format/legfi-date.pipe';
import { LegfiDatePipeModule } from '../../../../pipes/format/legfi-date.module';
import { MultiDocumentUploaderDialogComponent } from './multi-document-uploader-dialog.component';
import { TransactionsService } from '../../../../services/accounting/transactions.service';
import { LegfiFilesizePipe } from '../../../../pipes/format/legfi-filesize.pipe';
import { LegfiFilesizePipeModule } from '../../../../pipes/format/legfi-filesize.module';
import { UploadedFilesService } from 'app/services/uploaded-files.service';
import { MatLegacyDialogModule as MatDialogModule } from '@angular/material/legacy-dialog';
import { MatLegacyProgressBarModule as MatProgressBarModule } from '@angular/material/legacy-progress-bar';
import { MatIconModule } from '@angular/material/icon';

@NgModule({
    imports: [
        // Shared
        SharedModule,
        // Dependencies
        AddClassOnHoverModule,
        FileUploadModule,
        LegfiCurrencyPipeModule,
        LegfiDatePipeModule,
        LegfiFilesizePipeModule,
        MatDialogModule,
        MatProgressBarModule,
        MatButtonModule,
        SharedDirectivesModule,
        MatIconModule,
    ],
    exports: [MultiDocumentUploaderDialogComponent],
    declarations: [MultiDocumentUploaderDialogComponent],
    providers: [
        // Pipes
        LegfiCurrencyPipe,
        LegfiDatePipe,
        LegfiFilesizePipe,

        // Services
        PaymentGroupsService,
        TransactionsService,
        UploadedFilesService,
    ],
})
export class MultiDocumentUploaderDialogModule
{
}
